






























































































































































import { PropType } from 'vue';
import moment from 'moment';
import PaymentRequisitionApproverList from './PaymentRequisitionApproverList.vue';

import {
  IPaymentRequisition,
  IPaymentRequisitionAttachment,
  IUserData
} from '@/models';
import { User } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';
import PaymentRequisitionAPSpecialistListMenu from './PaymentRequisitionAPSpecialistListMenu.vue';
import PaymentRequisitionDetailDrawerOwnerSelector from './PaymentRequisitionDetailDrawerOwnerSelector.vue';
import { createFile } from '@/utils/helpers';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import PaymentRequisitionStatusDisplay from '../requisition-common/PaymentRequisitionStatusDisplay.vue';

export default mixins(auth, snackbar).extend({
  components: {
    PaymentRequisitionApproverList,
    PaymentRequisitionAPSpecialistListMenu,
    PaymentRequisitionDetailDrawerOwnerSelector,
    ErrorAlert,
    PaymentRequisitionStatusDisplay
  },
  name: 'PaymentRequisitionDetailDrawer',

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    }
  },

  data: () => ({
    mini: true,
    drawer: true,

    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    authProvider(): any {
      return this.$altoleapAccounts.authProvider;
    },

    currentUser(): User {
      return this.authProvider.getCurrentUser;
    },

    isUserPaymentRequisitionOwner(): boolean {
      return (
        this.authProvider.getCurrentUser.id ==
        (this.paymentRequisition.owner as IUserData).id!
      );
    },

    canAssignAPSpecialist(): boolean {
      return !!(
        this.paymentRequisition.ap_specialist &&
        this.userHasRoles(['AP Specialist', 'Payment Requisition Admin'])
      );
    }
  },

  methods: {
    moment,

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    downloadAttachment(attachment: IPaymentRequisitionAttachment) {
      this.clearAllErrors();
      this.$services.fileLoader
        .downloadFile(attachment.file as string)
        .then(data => {
          createFile(data, attachment.filename!);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);

          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        });
    }
  }
});
